import fetchTopicTree from './action-topic-list';
import { fetchArticle } from '../../contactUs/actions/action-article';
import { resetRelatedArticle } from '../../contactUs/actions/action-related-article';
import { updateBreadCrumbFromArticleContent } from './action-breadcrumb';
import getCommunityResults from './action-community-posts';
import getOpenCase from '../actions/action-case-checker';
import * as Page from '../../lib/page';
import poll from '../../lib/poll';
import { displayChatBot } from './action-chat-bot';
import { trackSetUp } from '../../lib/analytics-helper';

const validateFptiAndPAYPAL = () => {
  if (typeof window.fpti === 'undefined' || typeof window.PAYPAL === 'undefined') {
    return Promise.reject(false);
  }
  return Promise.resolve(window.fpti);
};

export default function fetchArticleContent(experience, faqid) {
  return (dispatch, getState) => {
    dispatch(resetRelatedArticle());
    const { topicList } = getState();
    if (topicList && topicList.topics && topicList.topics.length <= 0) {
      dispatch(fetchTopicTree(experience));
    }
    dispatch(fetchArticle(faqid, true))
      .then((response) => {
        // if the postChatBotServiceEnabled RC is false call displayChatBot()
        if (!Page.isChatBotPostServiceEnabled()) {
          dispatch(displayChatBot());
        }
        if (response && response.payload) {
          poll(validateFptiAndPAYPAL, 5, 100)
            .then(() => trackSetUp({ id: 'articlePage', link: `smarthelp-article|${faqid}`, hpid: faqid }))
            .catch(() => {});
          dispatch(updateBreadCrumbFromArticleContent(response.payload));
          dispatch(getCommunityResults({ title: response.payload.articleTitle, id: faqid }));
          if (Page.isLoggedIn() && Page.isDisputeArticle(response.payload.articleTitle)) {
            dispatch(getOpenCase());
          }
        } else {
          poll(validateFptiAndPAYPAL, 5, 100)
            .then(() => trackSetUp({ id: 'articleErrorPage', link: `smarthelp-error-article|${faqid}`, hpid: faqid }))
            .catch(() => {});
        }
      })
      .catch(() => {});
  };
}
